<template>
  <!-- 入库单 -->
  <div class="in-stock-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="单据编号" @keydown.enter="resetSearch" clearable>
            <template #prefix>单据编号</template>
          </el-input>
          <supplier-select v-model="searchInfo.supplierId" placeholder="请选择供应商">
            <template #prefix>供应商名称</template>
          </supplier-select>
          <el-select v-model="searchInfo.warehouseId" placeholder="请选择仓库" clearable filterable>
            <template #prefix>仓库名称</template>
            <el-option v-for="w in warehouseList" :key="w.id" :value="w.id" :label="w.warehouseName"/>
          </el-select>
          <employee-select v-model="searchInfo.operatorId" placeholder="请选择操作员">
            <template #prefix>操作员</template>
          </employee-select>
          <employee-select v-model="searchInfo.handlerId" placeholder="请选择操作员">
            <template #prefix>经手人</template>
          </employee-select>
          <el-select v-model="searchInfo.billType" placeholder="请选择入库类型" clearable>
            <template #prefix>入库类型</template>
            <el-option v-for="t in billTypeOptions" :key="t.code" :value="t.code" :label="t.name"/>
          </el-select>
          <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
            <template #prefix>状态</template>
            <el-option label="草稿" :value="1"/>
            <el-option label="已提交" :value="10"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="router.push('/stock/inStock/detail')">新建入库单</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="inStockList">
          <yq-table-column label="单据编号" prop="billNo" width="180rem">
            <template v-slot="{row}">
              <a @click="toDetail(row)">{{row.billNo}}</a>
            </template>
          </yq-table-column>
          <yq-table-column label="入库类型" prop="billTypeName" width="150rem" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="getTypeTag(row)">{{getTypeName(row)}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="供应商" prop="supplierName" min-width="180rem" />
          <yq-table-column label="仓库" prop="warehouseName" min-width="150rem">
            <template v-slot="{row}">{{getWarehouseName(row)}}</template>
          </yq-table-column>
          <yq-table-column label="操作员" prop="operatorName" width="120rem"/>
          <yq-table-column label="单据日期" prop="billDate" width="150rem" class-name="muted">
            <template v-slot="{row}">{{row.billDate? row.billDate.substring(0,10): '-'}}</template>
          </yq-table-column>
          <yq-table-column label="单据来源" prop="sourceTypeName" width="150rem" />
          <yq-table-column label="创建时间" prop="createdTime" :show-overflow-tooltip="true"/>
          <yq-table-column label="状态" prop="statusName" width="120rem" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="row.status === 1 ? 'warning' : 'success'">{{row.statusName}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="toDetail(row)">详情</table-button>
                <table-button v-if="row.status === 1" type="delete" el-type="danger" message="是否确认删除该入库单" @click="toDelete(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import inboundOrderApi from "@/api/normal/stock/inboundOrderApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import SupplierSelect from "@/components/h5/partner/SupplierSelect.vue";
import billTypeUtil from "@/views/h5/common/stock/BillTypeUtil";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "InStockList",
  components: {
    EmployeeSelect,
    YqTableColumn, TableButtonGroup, TableButton, SupplierSelect,
    SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {pageNumber: 1, pageSize: 10},
      dataList: [],
      billTypeOptions: [],
      warehouseList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.resetSearch();
    Util.getSystemSettingOptions("STOCK_IN_TYPE").then(list => this.billTypeOptions = list);
    commonDataApi.queryAllWarehouse().then(list => this.warehouseList = list);
  },
  methods: {
    getTypeTag(data) {
      return billTypeUtil.getBillTypeTag(data.billType);
    },
    getTypeName(data) {
      return billTypeUtil.getBillTypeName(data.billType)
    },
    getWarehouseName(data) {
      for (let i = 0; i < this.warehouseList.length; i++) {
        if (this.warehouseList[i].id === data.warehouseId) {
          return this.warehouseList[i].warehouseName;
        }
      }
      return "";
    },
    async queryList() {
      const {records, totalCount} = await inboundOrderApi.queryList(this.searchInfo);
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toDetail(row) {
      this.router.push(`/stock/inStock/detail?id=${row.id}`);
    },
    async toDelete(row) {
      await inboundOrderApi.delete(row.id);
      this.resetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.in-stock-list {
  height: 100%;
  .muted { color: var(--yq-font-color-desc); font-size: 12px; }
}
</style>
